module.exports = __webpack_public_path__ + "static/media/n.689067fc.svg";